



















































































































































































































import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {EventBus} from "@/helpers/event-bus";
import StandardQuestion from "@/components/question_components/StandardQuestion.vue";
import ImportanceQuestion from "@/components/question_components/ImportanceQuestion.vue";
import CommentQuestion from "@/components/question_components/CommentQuestion.vue";
import QuestionTooltip from "@/components/question_components/QuestionTooltip.vue";
import {SurveyTabType} from "@/types/surveyTab.type";
import {SurveyTabCollectionType} from "@/types/surveyComponent.type";

@Component({
    components: {
        StandardQuestion,
        ImportanceQuestion,
        CommentQuestion,
        QuestionTooltip
    }
})
export default class SurveyTab extends Vue {
    @Prop() currentTabData!: SurveyTabType;
    @Prop() currentTabName!: string;

    importanceTooltip =
        "Distribution curves demonstrate how election security subject matter experts (SMEs) historically have ranked the default importance of confidentiality, integrity, and availability of election systems. The frequency of expert response is shown here as a blue curve to demonstrate agreement (sharp peaks) or disagreement (broad slopes) across election security SMEs. <b>The importance of attack score is auto-populated based on expertise from the election community, but may be updated if desired.</b>";

    mounted() {
        EventBus.$on("update-tab-data", () => {
            this.setStore();
        });
        EventBus.$on("next-tab", () => {
            this.next();
        });
        EventBus.$on("save-progress", () => {
            this.setUpSave();
        });
        EventBus.$on("go-to-results", () => {
            this.goToResults();
        });
    }

    localQuestions = JSON.parse(JSON.stringify(this.currentTabData));
    nextClicked = false;
    dialog = false;

    next() {
        this.nextClicked = true;
        if (this.allDone) {
            this.setStore();
            this.$emit("nextTab", "next");
        } else {
            this.dialog = true;
        }
        window.scrollTo(0, 0);
    }

    setUpSave() {
        this.setStore();
        this.$emit("saveFile");
    }

    goToNextIncomplete() {
        this.dialog = false;
        this.setStore();
        this.$emit("nextTab", "next");
    }

    get showChildrenCards(): boolean {
        if (
            this.currentTabName === this.surveyTabs[8].name &&
            this.localQuestions.scaleQuestions.questions.tabulationAtPrecincts
                .userInput.answer === "No"
        ) {
            return false;
        } else return true;
    }

    get allDone() {
        if (
            this.localQuestions.scaleQuestions.complete == true &&
            this.localQuestions.accessQuestions.complete == true &&
            this.localQuestions.authQuestions.complete == true &&
            this.localQuestions.hardwareQuestions.complete == true &&
            this.localQuestions.softwareQuestions.complete == true &&
            this.localQuestions.ddosQuestions.complete == true
        ) {
            return true;
        } else {
            return false;
        }
    }

    get showAdditionalInformation() {
        if (
            this.currentTabName === "Aggregation (State)" ||
            this.currentTabName === "Pollbook Use" ||
            this.currentTabName === "Website"
        ) {
            return false;
        } else {
            return true;
        }
    }

    get surveyTabs(): SurveyTabCollectionType {
        return this.$store.getters.surveyTabs;
    }

    @Watch("currentTabData")
    updateCurrentTab() {
        this.localQuestions = this.currentTabData;
        this.nextClicked = false;
    }

    goToResults() {
        this.setStore();
        window.scrollTo(0, 0);
        this.$router.push("/risk-prioritization");
    }
    setStore() {
        this.$emit("setStore", this.localQuestions);
    }

    setAnswer(question: string) {
        const scaleQuestions = this.localQuestions.scaleQuestions.questions;
        const accessQuestions = this.localQuestions.accessQuestions.questions;
        const authQuestions = this.localQuestions.authQuestions.questions;
        const hardwareQuestions = this.localQuestions.hardwareQuestions
            .questions;
        const softwareQuestions = this.localQuestions.softwareQuestions
            .questions;
        const ddosQuestions = this.localQuestions.ddosQuestions.questions;

        // ************ Begin Scale Logic ************
        if (
            question === "networkedOrNonNetworked" &&
            this.currentTabName !== this.surveyTabs[8].name &&
            this.currentTabName !== this.surveyTabs[9].name
        ) {
            if (
                scaleQuestions.networkedOrNonNetworked.userInput.answer ===
                "Non-Networked"
            ) {
                scaleQuestions.jurisdictionOrState.show = false;
                scaleQuestions.scale.show = true;
                scaleQuestions.scale.userInput.answer = "Low";
                this.localQuestions.scaleQuestions.complete = true;
            } else {
                scaleQuestions.scale.show = false;
                scaleQuestions.scale.userInput.answer = null;
                this.localQuestions.scaleQuestions.complete = false;
                scaleQuestions.jurisdictionOrState.userInput.answer = null;
                scaleQuestions.jurisdictionOrState.show = true;
            }
        }

        // Special logic for Tabulation Use (Precinct) page
        if (this.currentTabName === this.surveyTabs[8].name) {
            if (
                scaleQuestions.tabulationAtPrecincts.userInput.answer == "Yes"
            ) {
                scaleQuestions.networkedOrNonNetworked.show = true;

                if (
                    scaleQuestions.networkedOrNonNetworked.userInput.answer ==
                    "Networked"
                ) {
                    scaleQuestions.scale.show = true;
                    scaleQuestions.scale.userInput.answer = "Medium";
                    this.localQuestions.scaleQuestions.complete = true;
                }

                if (
                    scaleQuestions.networkedOrNonNetworked.userInput.answer ==
                    "Non-Networked"
                ) {
                    scaleQuestions.scale.show = true;
                    scaleQuestions.scale.userInput.answer = "Low";
                    this.localQuestions.scaleQuestions.complete = true;
                }
            }
            if (scaleQuestions.tabulationAtPrecincts.userInput.answer == "No") {
                scaleQuestions.networkedOrNonNetworked.show = false;
                scaleQuestions.scale.show = false;
                scaleQuestions.scale.userInput.answer = "N/A";
            }
        }

        // Special logic for Tabulation Use (Central) page
        if (this.currentTabName === this.surveyTabs[9].name) {
            if (
                scaleQuestions.networkedOrNonNetworked.userInput.answer ===
                "Networked"
            ) {
                scaleQuestions.scale.show = true;
                scaleQuestions.scale.userInput.answer = "Medium";
                this.localQuestions.scaleQuestions.complete = true;
            }
            if (
                scaleQuestions.networkedOrNonNetworked.userInput.answer ===
                "Non-Networked"
            ) {
                scaleQuestions.scale.show = true;
                scaleQuestions.scale.userInput.answer = "Medium";
                this.localQuestions.scaleQuestions.complete = true;
            }
        }

        if (question === "jurisdictionOrState") {
            scaleQuestions.scale.show = true;
            this.localQuestions.scaleQuestions.complete = true;
            if (question === "jurisdictionOrState") {
                if (
                    scaleQuestions.jurisdictionOrState.userInput.answer ==
                    "Jurisdiction"
                ) {
                    scaleQuestions.scale.userInput.answer = "Medium";
                } else {
                    scaleQuestions.scale.userInput.answer = "High";
                }
            }
        }

        // ************ End Scale Logic ************

        // ************ Begin Access Logic ************
        // ---- Remote Access Group ----
        if (question === "remoteAccess") {
            if (accessQuestions.remoteAccess.userInput.answer == "Yes") {
                accessQuestions.remoteAccessNoAuth.userInput.answer = null;
                accessQuestions.anyIPS.userInput.answer = null;
                accessQuestions.allowList.userInput.answer = null;

                // For remote access parent question, update networked question depending on responses, only on the pages where networked question exists -ESA
                if (
                    (scaleQuestions.networkedOrNonNetworked != null &&
                        accessQuestions.remoteAccess.userInput.answer ===
                            "Yes") ||
                    (scaleQuestions.networkedOrNonNetworked != null &&
                        accessQuestions.proximateAccess.userInput.answer ===
                            "Yes")
                ) {
                    scaleQuestions.networkedOrNonNetworked.userInput.answer =
                        "Networked";
                }
            } else {
                accessQuestions.remoteAccessNoAuth.userInput.answer = "No";
                accessQuestions.anyIPS.userInput.answer = "No";
                accessQuestions.allowList.userInput.answer = "No";
            }
            accessQuestions.remoteAccessNoAuth.show = true;
            accessQuestions.anyIPS.show = true;
            accessQuestions.allowList.show = true;
        }

        //Set remote access to yes if any subquestions are set to yes
        if (
            question === "remoteAccessNoAuth" ||
            question === "anyIPS" ||
            question === "allowList"
        ) {
            if (
                accessQuestions.remoteAccessNoAuth.userInput.answer == "Yes" ||
                accessQuestions.anyIPS.userInput.answer == "Yes" ||
                accessQuestions.allowList.userInput.answer == "Yes"
            ) {
                accessQuestions.remoteAccess.userInput.answer = "Yes";

                // For remote access sub-questions, update networked question depending on responses, only on the pages where networked question exists -ESA
                if (
                    (scaleQuestions.networkedOrNonNetworked != null &&
                        accessQuestions.remoteAccess.userInput.answer ===
                            "Yes") ||
                    (scaleQuestions.networkedOrNonNetworked != null &&
                        accessQuestions.proximateAccess.userInput.answer ===
                            "Yes")
                ) {
                    scaleQuestions.networkedOrNonNetworked.userInput.answer =
                        "Networked";
                }
            }
        }

        // Update networked response on these tabs depending on access questions: -ESA
        if (
            this.currentTabName === this.surveyTabs[3].name ||
            this.currentTabName === this.surveyTabs[6].name ||
            this.currentTabName === this.surveyTabs[8].name ||
            this.currentTabName === this.surveyTabs[9].name
        ) {
            // Automatically set network question on these tabs to "networked" IF either remote access parent question OR proximate access parent question are "yes" (or if both are "yes". Physical access parent question does NOT impact networked/non-networked answer.
            if (
                accessQuestions.remoteAccess.userInput.answer === "Yes" ||
                accessQuestions.proximateAccess.userInput.answer === "Yes" ||
                (accessQuestions.remoteAccess.userInput.answer === "Yes" &&
                    accessQuestions.proximateAccess.userInput.answer === "Yes")
            ) {
                scaleQuestions.networkedOrNonNetworked.userInput.answer =
                    "Networked";
            }
        }

        // Set mitigations
        if (
            accessQuestions.remoteAccess.userInput.answer === "Yes" &&
            accessQuestions.remoteAccessNoAuth.userInput.answer === "Yes"
        ) {
            accessQuestions.remoteAccessNoAuth.showMitigation = true;
        } else {
            accessQuestions.remoteAccessNoAuth.showMitigation = false;
        }

        if (
            accessQuestions.remoteAccess.userInput.answer === "Yes" &&
            accessQuestions.anyIPS.userInput.answer === "No"
        ) {
            accessQuestions.anyIPS.showMitigation = true;
        } else {
            accessQuestions.anyIPS.showMitigation = false;
        }

        if (
            accessQuestions.remoteAccess.userInput.answer === "Yes" &&
            accessQuestions.allowList.userInput.answer === "No"
        ) {
            accessQuestions.allowList.showMitigation = true;
        } else {
            accessQuestions.allowList.showMitigation = false;
        }

        // ---- Proximate Access Group ----
        // show proximate access question if above anwers are complete
        if (
            accessQuestions.remoteAccessNoAuth.userInput.answer !== null &&
            accessQuestions.anyIPS.userInput.answer !== null &&
            accessQuestions.allowList.userInput.answer !== null
        ) {
            if (this.currentTabName === this.surveyTabs[4].name) {
                //if ballot prep tab
                accessQuestions.ballotLoading.show = true;
            }
            if (this.currentTabName === this.surveyTabs[5].name) {
                //if ballot prep tab
                accessQuestions.machineProgramming.show = true;
            }
            accessQuestions.proximateAccess.show = true;
        }

        if (question === "proximateAccess") {
            if (accessQuestions.proximateAccess.userInput.answer === "Yes") {
                accessQuestions.wifi.userInput.answer = null;
                accessQuestions.wpa2.userInput.answer = null;
                accessQuestions.wepOrWpa1.userInput.answer = null;
                accessQuestions.bluetooth.userInput.answer = null;
                accessQuestions.wpa2.show = false;
                accessQuestions.wepOrWpa1.show = false;
                // For proximate access sub-questions, update networked question depending on responses, only on the pages where networked question exists -ESA
                if (
                    (scaleQuestions.networkedOrNonNetworked != null &&
                        accessQuestions.remoteAccess.userInput.answer ===
                            "Yes") ||
                    (scaleQuestions.networkedOrNonNetworked != null &&
                        accessQuestions.proximateAccess.userInput.answer ===
                            "Yes")
                ) {
                    scaleQuestions.networkedOrNonNetworked.userInput.answer =
                        "Networked";
                }
            } else {
                accessQuestions.wifi.userInput.answer = "No";
                accessQuestions.wpa2.userInput.answer = "No";
                accessQuestions.wepOrWpa1.userInput.answer = "No";
                accessQuestions.bluetooth.userInput.answer = "No";
                accessQuestions.wpa2.show = true;
                accessQuestions.wepOrWpa1.show = true;
            }
            accessQuestions.wifi.show = true;

            accessQuestions.bluetooth.show = true;
        }

        //Set proximateAccess to yes if either 'wpa2' or 'wepOrWpa1' or 'bluetooth' is set to yes
        if (
            question === "wifi" ||
            question === "wpa2" ||
            question === "wepOrWpa1" ||
            question === "bluetooth"
        ) {
            if (
                accessQuestions.wifi.userInput.answer == "Yes" ||
                accessQuestions.wpa2.userInput.answer == "Yes" ||
                accessQuestions.wepOrWpa1.userInput.answer == "Yes" ||
                accessQuestions.bluetooth.userInput.answer == "Yes"
            ) {
                accessQuestions.proximateAccess.userInput.answer = "Yes";
                // For proximate access sub-questions, update networked question depending on responses, only on the pages where networked question exists -ESA
                if (
                    (scaleQuestions.networkedOrNonNetworked != null &&
                        accessQuestions.remoteAccess.userInput.answer ===
                            "Yes") ||
                    (scaleQuestions.networkedOrNonNetworked != null &&
                        accessQuestions.proximateAccess.userInput.answer ===
                            "Yes")
                ) {
                    scaleQuestions.networkedOrNonNetworked.userInput.answer =
                        "Networked";
                }
            }
        }

        // show wifi options if the wifi question is answered
        if (question === "wifi") {
            accessQuestions.wpa2.show = true;
            accessQuestions.wepOrWpa1.show = true;
            if (accessQuestions.wifi.userInput.answer == "No") {
                // set both wifi security options to no if "no wifi" is selected
                accessQuestions.wpa2.userInput.answer = "No";
                accessQuestions.wepOrWpa1.userInput.answer = "No";
            } else if (accessQuestions.wifi.userInput.answer == "Yes") {
                // if user newly selects yes, clear the wifi security questions so that user has to answer them
                accessQuestions.wpa2.userInput.answer = null;
                accessQuestions.wepOrWpa1.userInput.answer = null;
            }
        }

        // only allow picking one of the wep or wpa2 options
        if (
            question == "wepOrWpa1" &&
            accessQuestions.wepOrWpa1.userInput.answer == "Yes" &&
            accessQuestions.wifi.userInput.answer == "Yes"
        ) {
            accessQuestions.wpa2.userInput.answer = "No";
        }
        // only allow picking one of the wep or wpa2 options
        if (
            question == "wpa2" &&
            accessQuestions.wpa2.userInput.answer == "Yes" &&
            accessQuestions.wifi.userInput.answer == "Yes"
        ) {
            accessQuestions.wepOrWpa1.userInput.answer = "No";
        }

        // ensure that wifi is yes if either wpa or wep option are set to yes
        if (question === "wpa2" || question === "wepOrWpa1") {
            if (
                accessQuestions.wpa2.userInput.answer == "Yes" ||
                accessQuestions.wepOrWpa1.userInput.answer == "Yes"
            ) {
                accessQuestions.wifi.userInput.answer = "Yes";
            }
        }

        // ensure that proximate access is set to no if user selects no on all prox access questions
        if (
            accessQuestions.wifi.userInput.answer == "No" &&
            accessQuestions.wpa2.userInput.answer == "No" &&
            accessQuestions.wepOrWpa1.userInput.answer == "No" &&
            accessQuestions.bluetooth.userInput.answer == "No"
        ) {
            accessQuestions.proximateAccess.userInput.answer = "No";
        }

        // set mitigations for proximate access questions
        if (
            accessQuestions.proximateAccess.userInput.answer === "Yes" &&
            accessQuestions.wpa2.userInput.answer === "No"
        ) {
            accessQuestions.wpa2.showMitigation = true;
        } else {
            accessQuestions.wpa2.showMitigation = false;
        }

        // ---- Physical Access Group ----
        // show physical access question if above anwers are complete
        if (
            accessQuestions.wifi.userInput.answer !== null &&
            accessQuestions.wpa2.userInput.answer !== null &&
            accessQuestions.wepOrWpa1.userInput.answer !== null &&
            accessQuestions.bluetooth.userInput.answer !== null
        ) {
            accessQuestions.physicalMedia.show = true;
        } else {
            accessQuestions.physicalMedia.show = false;
        }

        if (question === "physicalMedia") {
            accessQuestions.removableMediaPolicy.show = true;
        }

        //Set physicalMedia to yes if 'removableMediaPolicy' is set to yes
        if (question === "removableMediaPolicy") {
            if (
                accessQuestions.removableMediaPolicy.userInput.answer == "Yes"
            ) {
                accessQuestions.physicalMedia.userInput.answer = "Yes";
            }
        }

        // Set Mitigations
        if (
            accessQuestions.physicalMedia.userInput.answer == "Yes" &&
            accessQuestions.removableMediaPolicy.userInput.answer == "No"
        ) {
            accessQuestions.removableMediaPolicy.showMitigation = true;
        } else {
            accessQuestions.removableMediaPolicy.showMitigation = false;
        }

        // Access Complete Logic
        if (
            accessQuestions.remoteAccess.userInput.answer !== null &&
            accessQuestions.remoteAccessNoAuth.userInput.answer !== null &&
            accessQuestions.anyIPS.userInput.answer !== null &&
            accessQuestions.allowList.userInput.answer !== null &&
            accessQuestions.proximateAccess.userInput.answer !== null &&
            accessQuestions.bluetooth.userInput.answer !== null &&
            accessQuestions.wifi.userInput.answer !== null &&
            accessQuestions.wepOrWpa1.userInput.answer !== null &&
            accessQuestions.wpa2.userInput.answer !== null &&
            accessQuestions.physicalMedia.userInput.answer !== null &&
            accessQuestions.removableMediaPolicy.userInput.answer !== null
        ) {
            if (
                this.currentTabName !== this.surveyTabs[4].name ||
                (this.currentTabName === this.surveyTabs[4].name &&
                    accessQuestions.ballotLoading.userInput.answer !== null) ||
                (this.currentTabName === this.surveyTabs[5].name &&
                    accessQuestions.machineProgramming.userInput.answer !==
                        null)
            ) {
                this.localQuestions.accessQuestions.complete = true;
            }
        }

        // ************ End Access Logic ************

        // ************ Begin Authethication Logic ************
        if (question === "anyAuth") {
            if (authQuestions.anyAuth.userInput.answer == "No") {
                authQuestions.sfa.userInput.answer = "No";
                authQuestions.mfa.userInput.answer = "No";
                authQuestions.tfa.userInput.answer = "No";
                authQuestions.ofa.userInput.answer = "No";
            } else {
                authQuestions.sfa.userInput.answer = null;
                authQuestions.mfa.userInput.answer = null;
                authQuestions.tfa.userInput.answer = null;
                authQuestions.ofa.userInput.answer = null;
            }
            authQuestions.sfa.show = true;
            authQuestions.mfa.show = true;
            authQuestions.tfa.show = false;
            authQuestions.ofa.show = false;
        }

        //Set 'mfa' & its sub-options to No if 'sfa' is set to yes
        if (question === "sfa") {
            if (authQuestions.sfa.userInput.answer == "Yes") {
                authQuestions.anyAuth.userInput.answer = "Yes";
                authQuestions.mfa.userInput.answer = "No";
                authQuestions.tfa.show = true;
                authQuestions.ofa.show = true;
                authQuestions.tfa.userInput.answer = "No";
                authQuestions.ofa.userInput.answer = "No";
            } else if (authQuestions.sfa.userInput.answer == "No") {
                //Unmark other options if 'sfa' gets reset back to no
                authQuestions.mfa.userInput.answer = null;
                authQuestions.tfa.userInput.answer = null;
                authQuestions.ofa.userInput.answer = null;
            }
        }

        // setup mfa sub questions if mfa is set to yes
        if (question === "mfa" && authQuestions.mfa.userInput.answer == "Yes") {
            authQuestions.sfa.userInput.answer = "No";
            authQuestions.anyAuth.userInput.answer = "Yes";
            authQuestions.tfa.show = true;
            authQuestions.ofa.show = true;
            authQuestions.tfa.userInput.answer = null;
            authQuestions.ofa.userInput.answer = null;
        }
        // Set 'sfa' option to No if ('tfa' or 'ofa') are set to yes
        if (
            (question === "tfa" &&
                authQuestions.tfa.userInput.answer == "Yes") ||
            (question === "ofa" && authQuestions.ofa.userInput.answer == "Yes")
        ) {
            authQuestions.anyAuth.userInput.answer = "Yes";
            authQuestions.mfa.userInput.answer = "Yes";
            authQuestions.sfa.userInput.answer = "No";
            authQuestions.tfa.show = true;
            authQuestions.ofa.show = true;
        }

        if (question === "tfa" && authQuestions.tfa.userInput.answer == "Yes") {
            authQuestions.mfa.userInput.answer = "Yes";
            authQuestions.ofa.userInput.answer = "No";
        }

        if (question === "ofa" && authQuestions.ofa.userInput.answer == "Yes") {
            authQuestions.mfa.userInput.answer = "Yes";
            authQuestions.tfa.userInput.answer = "No";
        }

        // Set parent anyAuth question to No if SFA and MFA child responses are both No
        if (
            authQuestions.sfa.userInput.answer == "No" &&
            authQuestions.mfa.userInput.answer == "No"
        ) {
            authQuestions.anyAuth.userInput.answer = "No";
            authQuestions.tfa.userInput.answer = "No";
            authQuestions.ofa.userInput.answer = "No";
        }

        // Set parent MFA question and main parent anyAuth question both to No if all MFA child responses are No
        if (
            authQuestions.tfa.userInput.answer == "No" &&
            authQuestions.ofa.userInput.answer == "No"
        ) {
            authQuestions.mfa.userInput.answer = "No";
        }

        // set to complete if all questions are answered
        if (
            authQuestions.anyAuth.userInput.answer !== null &&
            authQuestions.sfa.userInput.answer !== null &&
            authQuestions.mfa.userInput.answer !== null &&
            authQuestions.tfa.userInput.answer !== null &&
            authQuestions.ofa.userInput.answer !== null
        ) {
            this.localQuestions.authQuestions.complete = true;
        }

        // set mitigations

        // if noAuth set mitigation
        if (authQuestions.anyAuth.userInput.answer === "No") {
            authQuestions.anyAuth.showMitigation = true;
        } else {
            authQuestions.anyAuth.showMitigation = false;
        }

        // if sfa, set mitigation
        if (authQuestions.sfa.userInput.answer === "Yes") {
            authQuestions.sfa.showMitigation = true;
        } else {
            authQuestions.sfa.showMitigation = false;
        }

        if (
            authQuestions.mfa.userInput.answer === "Yes" &&
            authQuestions.tfa.userInput.answer === "Yes"
        ) {
            authQuestions.tfa.showMitigation = true;
        } else {
            authQuestions.tfa.showMitigation = false;
        }
        // ************ End Authentication Logic ************

        // ************ Begin Hardware Logic ************
        if (question === "patchHardware") {
            if (hardwareQuestions.patchHardware.userInput.answer === "No") {
                hardwareQuestions.patchHardwareElection.userInput.answer = "No";
            } else {
                hardwareQuestions.patchHardwareElection.userInput.answer = null;
            }
            hardwareQuestions.patchHardwareElection.show = true;
        }

        if (
            hardwareQuestions.patchHardware.userInput.answer !== null &&
            hardwareQuestions.patchHardwareElection.userInput.answer !== null
        ) {
            this.localQuestions.hardwareQuestions.complete = true;
        } else {
            this.localQuestions.hardwareQuestions.complete = false;
        }

        //Set patchHardware to yes if 'patchHardwareElection' is set to yes
        if (
            question === "patchHardwareElection" &&
            hardwareQuestions.patchHardwareElection.userInput.answer == "Yes"
        ) {
            hardwareQuestions.patchHardware.userInput.answer = "Yes";
        }

        // set mitigations
        if (hardwareQuestions.patchHardwareElection.userInput.answer === "No") {
            hardwareQuestions.patchHardware.showMitigation = true;
        } else {
            hardwareQuestions.patchHardware.showMitigation = false;
        }

        // ************ End Hardware Logic ************

        // ************ Begin Software Logic ************
        if (question === "patchSoftware") {
            if (softwareQuestions.patchSoftware.userInput.answer === "No") {
                softwareQuestions.patchSoftwareElection.userInput.answer = "No";
            } else {
                softwareQuestions.patchSoftwareElection.userInput.answer = null;
            }
            softwareQuestions.patchSoftwareElection.show = true;
        }

        if (
            softwareQuestions.patchSoftware.userInput.answer !== null &&
            softwareQuestions.patchSoftwareElection.userInput.answer !== null
        ) {
            this.localQuestions.softwareQuestions.complete = true;
        } else {
            this.localQuestions.softwareQuestions.complete = false;
        }

        //Set patchSoftware to yes if 'patchSoftwareElection' is set to yes
        if (
            question === "patchSoftwareElection" &&
            softwareQuestions.patchSoftwareElection.userInput.answer == "Yes"
        ) {
            softwareQuestions.patchSoftware.userInput.answer = "Yes";
        }

        // set mitigations
        if (softwareQuestions.patchSoftwareElection.userInput.answer === "No") {
            softwareQuestions.patchSoftware.showMitigation = true;
        } else {
            softwareQuestions.patchSoftware.showMitigation = false;
        }
        // ************ End Software Logic ************

        // ************ Begin DDoS Logic ************
        if (question === "ddosProtection") {
            if (
                this.currentTabName !== this.surveyTabs[4].name &&
                this.currentTabName !== this.surveyTabs[5].name &&
                this.currentTabName !== this.surveyTabs[7].name
            ) {
                this.localQuestions.ddosQuestions.complete = true;
            } else if (
                this.currentTabName === this.surveyTabs[4].name &&
                ddosQuestions.ddosProtection.userInput.answer !== null
            ) {
                this.localQuestions.ddosQuestions.complete = true;
            } else if (
                (this.currentTabName === this.surveyTabs[5].name ||
                    this.currentTabName === this.surveyTabs[7].name) &&
                ddosQuestions.ddosProtection.userInput.answer !== null
            ) {
                this.localQuestions.ddosQuestions.complete = true;
            }
        }

        // set mitigations
        if (
            this.localQuestions.ddosQuestions.questions.ddosProtection.userInput
                .answer === "No" ||
            ((this.currentTabName === "Voter Registration" ||
                this.currentTabName === "Pollbook Preparation" ||
                this.currentTabName === "Ballot Preparation" ||
                this.currentTabName === "Voting Machine Prep" ||
                this.currentTabName === "Tabulation Use (Precinct)" ||
                this.currentTabName === "Aggregation (State)" ||
                this.currentTabName === "Website") &&
                this.localQuestions.accessQuestions.questions.remoteAccess
                    .userInput.answer === "No") ||
            ((this.currentTabName === "Pollbook Use" ||
                this.currentTabName === "Voting Machine Use" ||
                this.currentTabName === "Tabulation Use (Central)") &&
                this.localQuestions.scaleQuestions.questions
                    .networkedOrNonNetworked.userInput.answer ===
                    "Non-Networked")
        ) {
            this.localQuestions.ddosQuestions.questions.ddosProtection.showMitigation = true;
        } else {
            this.localQuestions.ddosQuestions.questions.ddosProtection.showMitigation = false;
        }
        // ************ End DDoS Logic ************
    }

    //check if question is indented in liklihood of attack section
    isIndented(questionId: string) {
        if (
            questionId === "remoteAccess" ||
            questionId === "proximateAccess" ||
            questionId === "physicalMedia" ||
            questionId === "anyAuth" ||
            questionId === "sfa" ||
            questionId === "mfa" ||
            questionId === "patchHardware" ||
            questionId === "patchSoftware" ||
            questionId === "ddosProtection" ||
            questionId === "ballotLoading" ||
            questionId === "machineProgramming"
        ) {
            return false;
        } else {
            return true;
        }
    }

    //check if wifi access subquestions are extra nested
    veryIndented(questionId: string) {
        if (questionId === "wepOrWpa1" || questionId === "wpa2") {
            return true;
        } else {
            return false;
        }
    }

    hideSections(questionId: string) {
        if (
            // hide Remote Access section entirely on Tabulation Use (Precinct)
            // (this.currentTabName === "Tabulation Use (Precinct)" &&
            //     questionId === "remoteAccess") ||

            // hide DDOS section on these tabs only if user input for remote access question was "no"
            ((this.currentTabName === "Voter Registration" ||
                this.currentTabName === "Pollbook Preparation" ||
                this.currentTabName === "Ballot Preparation" ||
                this.currentTabName === "Voting Machine Prep" ||
                this.currentTabName === "Tabulation Use (Precinct)" ||
                this.currentTabName === "Aggregation (State)" ||
                this.currentTabName === "Website") &&
                this.localQuestions.accessQuestions.questions.remoteAccess
                    .userInput.answer === "No" &&
                questionId === "ddosProtection") ||
            // hide DDOS section on these tabs only if user input was "non-networked"
            ((this.currentTabName === "Pollbook Use" ||
                this.currentTabName === "Voting Machine Use" ||
                this.currentTabName === "Tabulation Use (Central)") &&
                this.localQuestions.scaleQuestions.questions
                    .networkedOrNonNetworked.userInput.answer ===
                    "Non-Networked" &&
                questionId === "ddosProtection")
        ) {
            // mark the ddos question complete so that form validation doesn't trigger for a hidden question
            this.localQuestions.ddosQuestions.complete = true;
            return true;
        } else {
            return false;
        }
    }

    hideSubTitle() {
        if (
            // hide Access section title string on Tabulation Use (Precinct) tab
            // this.localQuestions.accessQuestions.sectionTitle ===
            //     "Access to Precinct Tabulation System" ||

            // hide DDOS section title these tabs only if user input for remote access question was "no"
            ((this.currentTabName === "Voter Registration" ||
                this.currentTabName === "Pollbook Preparation" ||
                this.currentTabName === "Ballot Preparation" ||
                this.currentTabName === "Voting Machine Prep" ||
                this.currentTabName === "Tabulation Use (Precinct)" ||
                this.currentTabName === "Aggregation (State)" ||
                this.currentTabName === "Website") &&
                this.localQuestions.accessQuestions.questions.remoteAccess
                    .userInput.answer === "No" &&
                this.localQuestions.ddosQuestions.sectionTitle ===
                    "DDoS Protection") ||
            // hide DDOS section title on these tabs only if user input was "non-networked"
            ((this.currentTabName === "Pollbook Use" ||
                this.currentTabName === "Voting Machine Use" ||
                this.currentTabName === "Tabulation Use (Central)") &&
                this.localQuestions.scaleQuestions.questions
                    .networkedOrNonNetworked.userInput.answer ===
                    "Non-Networked" &&
                this.localQuestions.ddosQuestions.sectionTitle ===
                    "DDoS Protection")
        ) {
            return true;
        } else {
            return false;
        }
    }
}
